export default {
  itens: [],
  item: {},
  produtos: [],
  filtros: {
    tipo: "",
    data_inicial: "",
    data_final: "",
    produtos: "",
    status: ""
  },
  selects: {
    tipo: [
      { value: "1", text: "Promoção" },
      { value: "2", text: "Campanha" }
    ],
    seg_for_tipo: [
      { value: "idfamilia_produto", text: "Segmento" },
      { value: "idfornecedor", text: "Fornecedor" }
    ],
    status: [
      { value: "1", text: "Não iniciado" },
      { value: "2", text: "Em andamento" },
      { value: "3", text: "Finalizado" },
      { value: "4", text: "Interrompido" }
    ],
    filtros: [
      { value: "oportunidades", text: "Oportunidades" },
      { value: "emexcesso", text: "Em excesso" },
      { value: "foradelinha", text: "Fora de Linha" },
      { value: "nomoving", text: "No moving" }
    ]
  }
};
